import { render, staticRenderFns } from "./CardPatient.vue?vue&type=template&id=2a683261&scoped=true&lang=pug"
import script from "./CardPatient.vue?vue&type=script&lang=js"
export * from "./CardPatient.vue?vue&type=script&lang=js"
import style0 from "./CardPatient.vue?vue&type=style&index=0&id=2a683261&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a683261",
  null
  
)

export default component.exports